import React from 'react';
import { Card, CardBody, Button, Badge } from 'reactstrap';
import { Edit, Trash2, ToggleLeft, ToggleRight, Eye, Calendar, Award } from 'react-feather';

const MinigameCard = ({ minigame, onViewDetail, onToggleStatus, onEdit, onDelete }) => {
  const active = minigame.status === 'active';
  const now = new Date();
  const startDate = new Date(minigame.startDate);
  const endDate = new Date(minigame.endDate);
  const isUpcoming = startDate > now;
  const isOngoing = startDate <= now && endDate >= now;
  const isEnded = endDate < now;

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('vi-VN', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <Card className={`shadow-sm border h-100 hover-lift ${!active ? 'opacity-75' : ''}`}>
      <CardBody>
        {/* Header */}
        <div className="d-flex justify-content-between align-items-start mb-3">
          <div className="flex-grow-1">
            <h5 className="mb-2">{minigame.title}</h5>
            <p className="text-muted small mb-0 line-clamp-2">
              {minigame.description}
            </p>
          </div>
          <Badge 
            color={active ? 'success' : 'secondary'} 
            className="ms-2"
          >
            {active ? 'Active' : 'Inactive'}
          </Badge>
        </div>

        {/* Time Status Badge */}
        <div className="mb-3">
          {isUpcoming && (
            <Badge color="info" className="me-2">
              📅 Sắp diễn ra
            </Badge>
          )}
          {isOngoing && (
            <Badge color="success" className="me-2">
              🎯 Đang diễn ra
            </Badge>
          )}
          {isEnded && (
            <Badge color="danger" className="me-2">
              ⏰ Đã kết thúc
            </Badge>
          )}
        </div>

        {/* Info */}
        <div className="mb-3 small">
          <div className="d-flex align-items-center mb-2">
            <Calendar size={14} className="me-2 text-info" />
            <span className="text-muted">Bắt đầu:</span>
            <span className="ms-2">{formatDate(minigame.startDate)}</span>
          </div>
          <div className="d-flex align-items-center mb-2">
            <Calendar size={14} className="me-2 text-danger" />
            <span className="text-muted">Kết thúc:</span>
            <span className="ms-2">{formatDate(minigame.endDate)}</span>
          </div>
          <div className="d-flex align-items-center">
            <Award size={14} className="me-2 text-warning" />
            <span className="text-muted">Phần thưởng:</span>
            <span className="ms-2 fw-bold text-warning">{minigame.reward || 0} điểm</span>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="d-flex gap-1 flex-wrap">
          <Button
            color="info"
            size="sm"
            onClick={() => onViewDetail(minigame)}
            title="Xem chi tiết"
            className="flex-grow-1"
          >
            <Eye size={14} className="me-1" />
            Chi tiết
          </Button>
          <Button
            color={active ? 'success' : 'secondary'}
            size="sm"
            onClick={() => onToggleStatus(minigame._id, minigame.status)}
            title={active ? 'Vô hiệu hóa' : 'Kích hoạt'}
          >
            {active ? <ToggleRight size={14} /> : <ToggleLeft size={14} />}
          </Button>
          <Button
            color="warning"
            size="sm"
            onClick={() => onEdit(minigame)}
            title="Chỉnh sửa"
          >
            <Edit size={14} />
          </Button>
          <Button
            color="danger"
            size="sm"
            onClick={() => onDelete(minigame._id)}
            title="Xóa"
          >
            <Trash2 size={14} />
          </Button>
        </div>
      </CardBody>
    </Card>
  );
};

export default MinigameCard;

